<div [formGroup]="form">
    <mat-form-field style="width:100%;">
        <mat-label *ngIf="show">{{label}}</mat-label>
        <textarea matInput [formControlName]="name" [placeholder]="label" [id]="'input-' + label" [rows]="rows" #input></textarea>
        <mat-error *ngIf="form && form.get(name).hasError('required')">
            {{label}} est <strong>requise</strong>
        </mat-error>
    </mat-form-field>
</div>